export default __webpack_public_path__ + "static/media/accesorios.1ee489b7.png";